import { faUser } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';
import { theme } from '../theme';

export const ProfileIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faUser} color={props.color || theme.palette.fadedIconColor} />
  )
}
